<template>
  <!-- <div id="sidebar" class="scrollbar" :class="(collapseVar == true)? 'active' : ''"> -->
  <div
    id="sidebar"
    class="iconMobileLeftbar"
    :class="classMobileResponsive ? 'active' : 'inactive'"
  >
    <div class="cap_leftbar p_right">
      <div class="left_scrollbar">
        <!---------------left nav---------------->
        <nav class="side-navbar main-menu scrollbar">
          <ul id="side-main-menu" class="side-menu list-unstyled">
            <!--:class="(activeLi == 'dashboard')? 'active' : ''" @click="chnageLeft('dashboard')"-->
            <li>
              <router-link to="/dashboard" @click.native="addDashboardEventTrack">
                <i class="leftIco">
                  <img
                    src="../../../../static/fxView/images/dashboard.svg"
                    alt="Add Deposit"
                  />
                </i>
                <span class="menutxt">{{ $t("dashboard") }}</span>
              </router-link>
            </li>
            <li
              :class="activeLi == 'mnge' ? 'active' : ''"
              @click.prevent="chnageLeft('mnge')"
            >
              <router-link to="#" class="subMenuClass" @click.native="addManageAccountEvent">
                <i class="leftIco">
                  <img
                    src="../../../../static/fxView/images/manageaccount.svg"
                    alt="Add Deposit"
                  />
                </i>
                <span class="menutxt">{{ $t("manageAccount") }}</span>
                <feather type="chevron-down" class="down_arrow"></feather>
              </router-link>
              <ul class="sub_menu">
                <li>
                  <router-link :to="'/account-list'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/list.svg"
                        alt="Account List"
                      />
                    </i>
                    <span class="menutxt">{{ $t("accountList") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/change-leverage'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/leverageico.svg"
                        alt="Change Leverage"
                      />
                    </i>
                    <span class="menutxt">{{ $t("changeLeverage") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/account/change/password'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/password.svg"
                        alt="Change Password"
                      />
                    </i>
                    <span class="menutxt">{{ $t("changePassword") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/internal-transfer'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/internal_transfer.svg"
                        alt="Internal Transfer"
                      />
                    </i>
                    <span class="menutxt">{{ $t("internalTransfer") }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              :class="activeLi == 'deposit' ? 'active' : ''"
              @click.prevent="chnageLeft('deposit')"
            >
              <router-link to="#" class="subMenuClass">
                <i class="leftIco">
                  <img
                    src="../../../../static/fxView/images/deposit.svg"
                    alt="Add Deposit"
                  />
                </i>
                <span class="menutxt">{{ $t("deposit") }}</span>
                <feather type="chevron-down" class="down_arrow"></feather>
              </router-link>
              <ul class="sub_menu">
                <li>
                  <router-link :to="'/deposit'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/adddeposit.svg"
                        alt="Add Deposit"
                      />
                    </i>
                    <span class="menutxt">{{ $t("addDeposit") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/deposit-list'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/list.svg"
                        alt="Account List"
                      />
                    </i>
                    <span class="menutxt">{{ $t("depositList") }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li
              :class="activeLi == 'withdrawal' ? 'active' : ''"
              @click.prevent="chnageLeft('withdrawal')"
            >
              <router-link to="#" class="subMenuClass">
                <i class="leftIco">
                  <img
                    src="../../../../static/fxView/images/withdrawal.svg"
                    alt="Add Deposit"
                  />
                </i>
                <span class="menutxt">{{ $t("withdrawal") }}</span>
                <feather type="chevron-down" class="down_arrow"></feather>
              </router-link>
              <ul class="sub_menu">
                <li>
                  <router-link :to="'/withdrawal'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/widthrawal-icov1.svg"
                        alt="Account List"
                      />
                    </i>
                    <span class="menutxt">{{ $t("makewithdrawal") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/withdrawal-list'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/list.svg"
                        alt="Account List"
                      />
                    </i>
                    <span class="menutxt">{{ $t("withdrawalList") }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <!--<li  :class="(activeLi == 'bonus')? 'active' : ''" @click="chnageLeft('bonus')">
                            <router-link to="#" class="subMenuClass">                                
                                <i class="leftIco">
                                    <img src="../../../../static/fxView/images/addbonus.svg" alt="Add Deposit">
                                </i>
                                <span class="menutxt">{{$t('bonus')}}</span> 
                                <feather type="chevron-down" class="down_arrow"></feather>
                            </router-link>
                            <ul class="sub_menu">
                                <li>
                                    <router-link :to="'/bonus'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Account List">
                                        </i>
                                        <span class="menutxt">{{$t('bonus')}}</span> 
                                    </router-link> 
                                </li>
                                <li>
                                    <router-link :to="'/bonus-list'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Account List">
                                        </i>
                                        <span class="menutxt">{{$t('bonusList')}}</span> 
                                    </router-link> 
                                </li>
								<li>
                                    <router-link :to="'/remove-bonus'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Account List">
                                        </i>
                                        <span class="menutxt">{{$t('removeBonus')}}</span> 
                                    </router-link> 
                                </li>
                            </ul> 
                        </li>  --->

            <li
              :class="activeLi == 'tools' ? 'active' : ''"
              @click.prevent="chnageLeft('tools')"
            >
              <router-link to="#" class="subMenuClass" @click.native="addToolsEvent">
                <i class="leftIco">
                  <img
                    src="../../../../static/fxView/images/tools.svg"
                    alt="tools"
                  />
                </i>
                <span class="menutxt">{{ $t("tools") }}</span>
                <feather type="chevron-down" class="down_arrow"></feather>
              </router-link>
              <ul class="sub_menu">
                <!-- <li>
                  <router-link :to="'/auto-chartist'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/list.svg"
                        alt="Auto Chartist"
                      />
                    </i>
                    <span class="menutxt">{{ $t("AutoChartist") }}</span>
                  </router-link>
                </li> -->
                <!-- <li>
                  <router-link :to="'/signal-centre'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/list.svg"
                        alt="Signal Center"
                      />
                    </i>
                    <span class="menutxt">{{ $t("SignalCenter") }}</span>
                  </router-link>
                </li> -->
                <li>
                  <router-link :to="'/news'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/news-icon.svg"
                        alt="News"
                      />
                    </i>
                    <span class="menutxt">{{ $t("news") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/tutorials'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/video-tutorial-icon.svg"
                        alt="Tutorials"
                      />
                    </i>
                    <span class="menutxt">{{ $t("tutorials") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/market-insight'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/market-insight-icon.svg"
                        alt="Market Insight"
                      />
                    </i>
                    <span class="menutxt">{{ $t("market_insight") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/vps-list'" @click.native="addVPSEvent">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/vps-cloud.svg"
                        alt="Signal Center"
                      />
                    </i>
                    <span class="menutxt">{{ $t("VPS") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/economic-calendar'" @click.native="addEconomicCal">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/economic-calender-icon.svg"
                        alt="Signal Center"
                      />
                    </i>
                    <span class="menutxt">{{ $t("EconomicCalender") }}</span>
                  </router-link>
                </li>
                <!-- <li>
                  <router-link :to="'/trade-news'">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/list.svg"
                        alt="Signal Center"
                      />
                    </i>
                    <span class="menutxt">{{ $t("TradeNews") }}</span>
                  </router-link>
                </li> -->
                <li>
                  <router-link :to="'/tradertool-box'" @click.native="addTraderstoolEvent">
                    <i class="leftIco">
                      <img
                        src="../../../../static/fxView/images/trader-tool-icon.svg"
                        alt="Signal Center"
                      />
                    </i>
                    <span class="menutxt">Trader’s Tool Box</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <!-- <li>
              <router-link to="/zulutrade">
                <i class="leftIco">
                  <img
                    src="../../../../static/fxView/images/zulu_trade.svg"
                    alt="Add Deposit"
                  />
                </i>
                <span class="menutxt">{{ $t("zulu_trade") }}</span>
              </router-link>
            </li> -->

            <li
              :class="activeLi == 'support' ? 'active' : ''"
              @click.prevent="chnageLeft('support')"
            >
              <router-link
                :to="{
                  name: 'fxView.support',
                  params: { tabName: 'requestServiceElement' },
                }"
                @click.native="addSupportEvent"
              >
                <i class="leftIco">
                  <img
                    src="../../../../static/fxView/images/support.svg"
                    alt="Support"
                  />
                </i>
                <span class="menutxt">{{ $t("support") }}</span>
              </router-link>
            </li>
          </ul>
        </nav>
        <!-- <app-language :page="'left-bar'"> </app-language> -->
        <!------------------------------------->
      </div>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import language from "./language";

export default {
  name: "Dashboard",
  mixins: [fxViewMixins],
  data() {
    return {
      showStepComponent: false,
      activeLi: "",
    };
  },
  props: ["classMobileResponsive"],
  components: {
    appLanguage: language,
  },
  computed: {
    userAccess() {
      if (this.get_user && this.get_user.roles) {
        let roles = this.get_user.roles.split("&");
        if (roles.includes("TEST")) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    chnageLeft(left) {
      if (this.activeLi == left) {
        this.activeLi = "";
      } else {
        this.activeLi = left;
      }
    },
    addDashboardEventTrack(){
      this.$trackEvent('CP+Menu+Dashboard');
    },
    addManageAccountEvent(){
      this.$trackEvent('CP+Menu+Manage+Accounts');
    },
    addToolsEvent(){
      this.$trackEvent('CP+Menu+Tools');
    },
    addSupportEvent(){
      this.$trackEvent('CP+Menu+Support');
    },
    addVPSEvent(){
      this.$trackEvent('CP+Tools+VPS');
    },
    addEconomicCal(){
      this.$trackEvent('CP+Tools+Econmic+Calendar');
    },
    addTraderstoolEvent(){
      this.$trackEvent("CP+Tools+Trader's+tools+box");
    }
  },
  mounted() {
    var ww = document.body.clientWidth;
    const _that = this;
    if (ww < 991) {
      _that.$parent.classMobileResponsive = false;
      $(document).on("click", function (event) {
        if (
          !$(event.target).closest(".subMenuClass").length &&
          !$(event.target).closest(".iconMobile").length
        ) {
          _that.$parent.classMobileResponsive = false;
        }
      });
    } else if (ww >= 992) {
      _that.$parent.classMobileResponsive = true;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/left_navbar.vue